module.exports = __webpack_public_path__ + "static/media/dark-refresh-icon.9bdc5150.svg";